// extracted by mini-css-extract-plugin
export default {"content":"PostItem_content__pKbtZ","buttons":"PostItem_buttons__uAV9A","body":"PostItem_body__wEF2U"};